import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ToastNotification from "./components/toasts/ToastNotification/ToastNotification";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import "./styles/theme.css";
import "./styles/globals.css";
import "./styles/buttons.css";
import { ThemeProvider, applyInitialTheme } from "./hooks/useTheme";

applyInitialTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <ErrorBoundary>
          <ToastNotification />
          <App />
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
